import { post } from '@/utils/request'
export function getList(data) {
    return post('admin/log/listLog', data)
}
